import React from 'react';
import { render, screen } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import ConfigProvider from 'components/ConfigProvider';

import UserHeader from './UserHeader';

const pair = (account, permission) => ({ account, permission });

const renderHeader = (props = {}) =>
  render(
    <ConfigProvider>
      <UserHeader
        fullName="Abe Martinez"
        lastLoginAt="03/08/2025 05:22 PM MST"
        permissionAssignments={[pair('Account Name A', 'Fleet Administrator')]}
        {...props}
      />
    </ConfigProvider>,
  );

describe('management/EditUser UserHeader', () => {
  it('titles the page for the user', () => {
    renderHeader();

    expect(
      screen.getByRole('heading', { name: 'Edit Abe Martinez' }),
    ).toBeInTheDocument();
  });

  it('shows the last ecosystem login as the server formatted it', () => {
    renderHeader();

    expect(
      screen.getByText('Last Login 03/08/2025 05:22 PM MST'),
    ).toBeInTheDocument();
  });

  // Never logging in is normal for a freshly created user, and has to read as "no
  // value" rather than crash or print a zero date.
  it('falls back to a placeholder for a user who never logged in', () => {
    renderHeader({ lastLoginAt: undefined });

    expect(screen.getByText('Last Login —')).toBeInTheDocument();
  });

  describe('the account and role pairs', () => {
    it('shows each account beside the role held there', () => {
      renderHeader();

      expect(screen.getByText('Account Name A')).toBeInTheDocument();
      expect(screen.getByText('Fleet Administrator')).toBeInTheDocument();
    });

    it('renders nothing when the user holds no roles', () => {
      renderHeader({ permissionAssignments: [] });

      expect(screen.queryByText('Account Name A')).not.toBeInTheDocument();
    });

    // The design shows two pairs inline and collapses the remainder behind a count.
    it('keeps two inline and counts the rest', () => {
      renderHeader({
        permissionAssignments: [
          pair('Account Name A', 'Fleet Administrator'),
          pair('Account Name B', 'Manager'),
          pair('Account Name C', 'Member'),
        ],
      });

      expect(screen.getByText('Account Name A')).toBeInTheDocument();
      expect(screen.getByText('Account Name B')).toBeInTheDocument();
      expect(screen.queryByText('Account Name C')).not.toBeInTheDocument();
      expect(screen.getByText('1')).toBeInTheDocument();
    });

    it('reveals the rest when the counter is opened', () => {
      renderHeader({
        permissionAssignments: [
          pair('Account Name A', 'Fleet Administrator'),
          pair('Account Name B', 'Manager'),
          pair('Account Name C', 'Member'),
        ],
      });

      userEvent.click(
        screen.getByRole('button', {
          name: 'Show all accounts and roles (1 more)',
        }),
      );

      expect(screen.getByText('Account Name C')).toBeInTheDocument();
      expect(screen.getByText('Member')).toBeInTheDocument();
    });

    it('does not offer a counter when everything already fits', () => {
      renderHeader({
        permissionAssignments: [
          pair('Account Name A', 'Fleet Administrator'),
          pair('Account Name B', 'Manager'),
        ],
      });

      expect(
        screen.queryByRole('button', { name: /Show all accounts/ }),
      ).not.toBeInTheDocument();
    });
  });
});
